"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var Subject_1 = require("rxjs/Subject");
var WfActionCommentDialog = /** @class */ (function () {
    function WfActionCommentDialog(dialogRef, data, messageService, languageService, cdRef) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.messageService = messageService;
        this.languageService = languageService;
        this.cdRef = cdRef;
        this.title = '';
        this.commentError = '';
        this.ngUnsubscribe = new Subject_1.Subject();
    }
    WfActionCommentDialog.prototype.ngOnInit = function () {
        var _this = this;
        this.languageService.getInputLanguages().takeUntil(this.ngUnsubscribe)
            .subscribe(function (languages) { return _this._languages = languages; });
        this.messageService.getMessageWithPlaceholder("portfolio.action.confirm.message", [this.data.itemsCount + '']).takeUntil(this.ngUnsubscribe).subscribe(function (message) { return _this.title = message; });
        this.messageService.getMessage('portfolio.action.submit.comment.error.message').takeUntil(this.ngUnsubscribe).subscribe(function (message) { return _this.commentErrorMessage = message; });
    };
    WfActionCommentDialog.prototype.ngAfterViewInit = function () {
        this.isWfActionCommentDialogInitialized = true;
        this.cdRef.detectChanges();
    };
    WfActionCommentDialog.prototype.onCancelClick = function () {
        this.dialogRef.close({ 'submit': false });
    };
    WfActionCommentDialog.prototype.onMoveClick = function () {
        if (!this.data.isCommentRequired || this.comment && Array.from(this.comment.toMap().values()).every(function (m) { return m != '' && m != undefined && m != null; })) {
            this.commentError = '';
            this.dialogRef.close({ 'submit': true, 'comment': this.comment });
        }
        else {
            this.commentError = this.commentErrorMessage;
        }
    };
    Object.defineProperty(WfActionCommentDialog.prototype, "languages", {
        get: function () {
            return this._languages;
        },
        enumerable: true,
        configurable: true
    });
    WfActionCommentDialog.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    WfActionCommentDialog.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-wf-action-confirm-dialog',
                    styles: [require('./wf-action-comment-dialog.component.css')],
                    template: require('./wf-action-comment-dialog.component.html')
                },] },
    ];
    /** @nocollapse */
    WfActionCommentDialog.ctorParameters = function () { return [
        { type: material_1.MatDialogRef, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [material_1.MAT_DIALOG_DATA,] },] },
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
        { type: core_1.ChangeDetectorRef, },
    ]; };
    return WfActionCommentDialog;
}());
exports.WfActionCommentDialog = WfActionCommentDialog;
//# sourceMappingURL=wf-action-comment-dialog.component.js.map